<template>
    <div class="user">
        <div class="condition">
            
            <div class="item">
                <div class="label">用户昵称:</div>
                <el-input v-model="conditionData.nickName" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">用户ID:</div>
                <el-input v-model="conditionData.userId" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">性别:</div>
                <el-select v-model="conditionData.gender" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in genderList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">手机号码:</div>
                <el-input v-model="conditionData.phone" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">省份:</div>
                <el-input v-model="conditionData.province" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">城市:</div>
                <el-input v-model="conditionData.City" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">微信号:</div>
                <el-input v-model="conditionData.weChat" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">QQ:</div>
                <el-input v-model="conditionData.qq" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">是否会员:</div>
                <el-select v-model="conditionData.vip" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in vipList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">用户状态:</div>
                <el-select v-model="conditionData.state" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in enableList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">*:</div>
                <el-select v-model="conditionData.isReal" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in isList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <!-- <div class="item">
                <div class="label">是否测试用户:</div>
                <el-select v-model="conditionData.isTest" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in isList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">微信装审核状态:</div>
                <el-select v-model="conditionData.reviewWeChatState" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in reviewWeChatStateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
                <!-- <el-button type="success" size="small" @click="getUserData()">下载excel</el-button> -->
                <!-- <el-button type="success" size="small" @click="expertUser()">导出用户</el-button> -->
                <!-- <el-button type="danger" size="small" @click="isSetNum = true">设置在线数</el-button> -->
                
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <!-- <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%"
                height="600px">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="table-expand">
                            <el-form-item label="用户账号:">
                                <div class="row">
                                    <span>{{ props.row.phone }}{{ props.row.isReal?'*':'' }}</span>
                                    <div class="btn">
                                        <el-button type="text" @click="showHeader(props.row.header)">(查看头像)</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                            
                            <el-form-item label="情感:">
                                <span>{{ props.row.love }}</span>
                            </el-form-item>
                            <el-form-item label="金币数量:">
                                <div class="row">
                                    <span>{{ props.row.jinBi }}</span>
                                    <!-- <div class="btn">
                                        <el-button type="text" @click="showHeader(props.row.header)">(修改)</el-button>
                                    </div> -->
                                </div>
                            </el-form-item>
                            <el-form-item label="用户昵称:">
                                <span>{{ props.row.nickName }}</span>
                            </el-form-item>
                            <!-- <el-form-item label="是否真实用户:">
                                <span>{{ props.row.isJUser?'真实':'否' }}</span>
                            </el-form-item> -->
                            <el-form-item label="真实照片:" v-if="props.row.zhenRenBase&&props.row.gender==2">
                                <div class="row">
                                    <div class="btn">
                                        <el-button type="text" @click="showHeader(props.row.zhenRenBase)">真实照片</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="微信:" v-if="props.row.gender==2">
                                <span>{{ props.row.weChat }}</span>
                            </el-form-item>
                            <el-form-item label="QQ:" v-if="props.row.gender==2">
                                <span>{{ props.row.qq }}</span>
                            </el-form-item>
                            <el-form-item label="主页查看次数:">
                                <span>{{ props.row.lookInfoNumber }}</span>
                            </el-form-item>
                            <el-form-item label="性别:">
                                <span>{{ props.row.gender==1?'男':'女' }}</span>
                            </el-form-item>
                            <el-form-item label="标签:">
                                <span>{{ props.row.tag?props.row.tag:'暂无' }}</span>
                            </el-form-item>
                            <el-form-item label="查看微信次数:">
                                <div class="row">
                                    <span>{{ props.row.unlockNumber }}</span>
                                    <div class="btn">
                                        <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="setUnlockNumber(props.row)">(解锁次数)</el-button>
                                    </div>
                                </div>

                            </el-form-item>
                            
                            <el-form-item label="年龄:">
                                <span>{{ props.row.age }}岁</span>
                            </el-form-item>
                            <el-form-item label="支付宝账号:">
                                <span>{{ props.row.userInfoVo.aliPayAccount?props.row.userInfoVo.aliPayAccount:'-' }}</span>
                            </el-form-item>
                            <el-form-item label="发表动态次数:">
                                <div class="row">
                                    <span>{{ props.row.dynamicNumber }}</span>
                                    <div class="btn">
                                        <el-button type="text" @click="dynamicNumberDialog(props.row)">(修改)</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="城市:">
                                <span>{{ props.row.province }}</span>
                                -
                                <span>{{ props.row.city }}</span>
                            </el-form-item>
                            <el-form-item label="真实姓名:">
                                <span>{{ props.row.userInfoVo.realName?props.row.userInfoVo.realName:'-' }}</span>
                            </el-form-item>
                            <el-form-item label="相册详情:">
                                <div class="btn">
                                    <el-button type="text" @click="isDetailDialogShow(props.row)">点击查看</el-button>
                                </div>
                            </el-form-item>
                            <el-form-item label="职业:">
                                <span>{{ props.row.zhiYe }}</span>
                            </el-form-item>
                            
                            <el-form-item label="真人验证:">
                                <span>
                                    {{ props.row.zhenRen==-1?'认证失败':'' }}
                                    {{ props.row.zhenRen==0?'未认证':'' }}
                                    {{ props.row.zhenRen==1?'认证中':'' }}
                                    {{ props.row.zhenRen==2?'已认证':'' }}
                                </span>
                            </el-form-item>
                            <el-form-item label="动态详情:">
                                <div class="btn">
                                    <el-button type="text" @click="dynamicNumberDialog(props.row)">点击查看</el-button>
                                </div>
                            </el-form-item>
                            <el-form-item label="身高:">
                                <span>{{ props.row.shenGao }}</span>
                            </el-form-item>
                            <el-form-item label="VIP状态:" v-if="props.row.gender==1">
                                <div class="row">
                                    <span>{{ props.row.vip?'是，':'否' }} {{ props.row.vipEndDate }}</span>
                                    <div class="btn">
                                        <el-button type="text" size="mini" @click="vip(props.row)">(vip设置)</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                            

                            <el-form-item label="设备类型:">
                                <span>{{props.row.userInfoVo.deviceName}}</span>
                            </el-form-item>
                            <el-form-item label="app版本:">
                                <span>{{props.row.userInfoVo.version}}</span>
                            </el-form-item>
                            <!-- <el-form-item label="应用包:">
                                <span>{{props.row.phoneType==0?'通用':''}}</span>
                                <span>{{props.row.phoneType==1?'华为':''}}</span>
                                <span>{{props.row.deviceType==1&&props.row.phoneType==2?'小米':''}}</span>
                                <span>{{props.row.deviceType==2&&props.row.phoneType==2?'IOS':''}}</span>
                                <span>{{props.row.phoneType==3?'Oppo':''}}</span>
                                <span>{{props.row.phoneType==4?'Vivo':''}}</span>
                                <span>{{props.row.phoneType==5?'三星':''}}</span>
                                <span>{{props.row.phoneType==10?'IOS':''}}</span>
                                <span>{{props.row.phoneType==11?'荣耀':''}}</span>
                                <span>{{props.row.phoneType==20?'h5':''}}</span>
                                <span>{{props.row.version}}</span>
                                
                            </el-form-item> -->

                            <el-form-item label="体重:">
                                <span>{{ props.row.tiZhong }}</span>
                            </el-form-item>
                            <el-form-item label="账号状态:">
                                <span>
                                    {{ props.row.enable==-3?'拉黑':'' }}
                                    {{ props.row.enable==-2?'注销':'' }}
                                    {{ props.row.enable==-1?'冻结':'' }}
                                    {{ props.row.enable==0?'审核中':'' }}
                                    {{ props.row.enable==1?'正常':'' }}
                                    (IP地址:{{ props.row.loginIp }})
                                </span>
                            </el-form-item>
                            <el-form-item label="是否分佣团队:">
                                <div class="row">
                                    <span>{{ props.row.isAgent?'是':'否' }}</span>
                                    <div class="btn">
                                        <el-button type="text" size="mini" @click="AgentDialog(props.row,1)">（设置分佣）</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="团队分佣比例:">
                                <div class="row">
                                    <span>{{ props.row.yongJinRatio*100 }}%</span>
                                    <div class="btn">
                                        <el-button type="text" size="mini" @click="AgentDialog(props.row,2)">（设置分佣）</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                           
                            <el-form-item label="是否设置中介:">
                                <div class="row">
                                    <span>{{ props.row.isZhongJie?'是':'否' }}</span>
                                    <div class="btn">
                                        <el-button type="text" size="mini" @click="intermediaryDialog(props.row,1)">（设置分佣）</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="团长列表:" v-if="props.row.isZhongJie">
                                <div class="row">
                                    <div class="btn">
                                        <el-button type="text" size="mini" @click="tuanZhangListDialog(props.row)">查看团长</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="最后操作时间:">
                                <span>{{ props.row.userInfoVo?props.row.userInfoVo.operationTime:'' }}</span>
                            </el-form-item>
                        </el-form>
                        
                    </template>
                    </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="userId"
                label="用户ID"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                label="账号"
                align="center"
                >
                <template slot-scope="scope">
                    <span>{{ scope.row.phone }}</span>
                    
                </template>
                </el-table-column>
                <!-- <el-table-column
                prop="isJUser"
                label="是否真实用户"
                align="center"
                width="110px"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isJUser">真实用户</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column> -->
                <el-table-column
                prop="nickName"
                label="用户昵称"
                align="center"
                >
                <template slot-scope="scope">
                    <span>{{ scope.row.nickName }}</span>

                    <span v-if="scope.row.isJUser">(*)</span>
                    <span v-else></span>
                </template>
                </el-table-column>
                
                <!-- <el-table-column
                prop="age"
                label="年龄"
                align="center"
                width="70"
                >
                </el-table-column> -->
                
                <el-table-column
                prop="gender"
                label="性别"
                align="center"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.gender==1">男</span>
                        <span v-else>女</span>
                    </template>
                </el-table-column>

                <!-- <el-table-column
                prop="shenhe"
                label="审核状态"
                align="center"
                width="140"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.shenhe==-1">审核失败</span>
                        <span v-else-if="scope.row.shenhe==1">审核中</span>
                        <span v-else>审核通过</span>
                    </template>
                </el-table-column> -->
                <el-table-column
                prop="weChat"
                label="微信"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="city"
                label="城市"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="vip"
                label="VIP状态"
                align="center"
                >
                 <template slot-scope="scope">
                    <div>{{scope.row.vip?'是':''}}</div>
                    <div>{{!scope.row.vip?'否':''}}</div>
                    <div>{{scope.row.vipEndDate?scope.row.vipEndDate:''}}</div>
                </template>
                </el-table-column>
                <el-table-column
                prop="jinBi"
                label="提现金币"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="money"
                label="提现金额"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="userInfoVo.deviceName"
                label="设备名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="state"
                label="账号状态"
                align="center"
                >
                <template slot-scope="scope">
                    {{ scope.row.state==-3?'拉黑':'' }}
                    {{ scope.row.state==-2?'注销':'' }}
                    {{ scope.row.state==-1?'冻结':'' }}
                    {{ scope.row.state==0?'审核中':'' }}
                    {{ scope.row.state==1?'正常':'' }}
                </template>
                </el-table-column>
                <!-- <el-table-column
                prop="deviceType"
                label="设备类型"
                align="center"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.deviceType==1?'Android':''}}</span>
                    <span>{{scope.row.deviceType==2?'IOS':''}}</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="PhoneType"
                label="应用包"
                align="center"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.phoneType==0?'通用':''}}</span>
                    <span>{{scope.row.phoneType==1?'华为':''}}</span>
                    <span>{{scope.row.phoneType==2?'小米':''}}</span>
                    <span>{{scope.row.phoneType==3?'Oppo':''}}</span>
                    <span>{{scope.row.phoneType==4?'Vivo':''}}</span>
                    <span>{{scope.row.phoneType==5?'三星':''}}</span>
                    <span>{{scope.row.phoneType==10?'苹果':''}}</span>
                </template>
                </el-table-column> -->
                <el-table-column
                prop="creationTime"
                label="创建时间"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="250px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="dongjieTip(scope.row)" v-if="scope.row.state==1">冻结</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="jiedongTip(scope.row)" v-if="scope.row.state==-1">解冻</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="addBacktTip(scope.row)">拉黑</el-button>
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="setJinBiTip(scope.row)">设置金币</el-button>
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="vip(scope.row)">设置会员</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="updateTip(scope.row)">编辑</el-button>
                    <!-- <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteTip(scope.row)">删除</el-button> -->


                    <el-button type="text" icon="el-icon-edit" size="mini" @click="SendZeGoMsgTip(scope.row)">互动通知</el-button>

                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="sizes,prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size"
                    :page-sizes="[10,50,100 ]"
                    @size-change="handleSizeChange">
                </el-pagination>
                
            </div>
        </div>
      
        <el-dialog :close-on-click-modal="false" :visible.sync="isFrozenDialog" :title="'冻结用户-'+username" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        冻结原因
                    </div>
                    <div class="valuet">
                        <el-input v-model="frozenData.reason" size="small" placeholder="请输入" type="textarea" :rows="4"></el-input>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="dongjie()">确认</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isAddBackDialog" title="加入黑名单" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        原因
                    </div>
                    <div class="value" style="width:400px">
                        <el-input v-model="addBackData.reason" placeholder="" type="textarea"></el-input>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="LaHei()">确认</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditDialog" :title="'编辑用户-'+username" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户昵称
                    </div>
                    <div class="valuet">
                        <el-input v-model="editData.nickName" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用户头像
                    </div>
                    <div class="header">
                        <el-upload
                            action=""
                            Multiple
                            :show-file-list="false"
                            :http-request="uploadHeader"
                            >
                            <el-button type="primary" icon="el-icon-upload" size="small" style="margin-right: 10px">上传图片</el-button>
                        </el-upload>
                        <el-image
                        style="width: 100px; height: 100px"
                        :src="editData.header"
                        :preview-src-list="[editData.header]"
                        fit="cover"></el-image>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        微信号
                    </div>
                    <div class="valuet">
                        <el-input v-model="editData.weChat" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="editDataFun()">确认</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isVip" title="设置会员" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        是否会员
                    </div>
                    <div class="value">
                        <el-select v-model="vipData.vip" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in vipList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        会员结束时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="vipData.vipEndDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        size="small"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="setVip()">确认</el-button>
                </div>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isJinBiDialog" title="设置金币" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        金币
                    </div>
                    <div class="value">
                        <el-input v-model="JinBiData.jinBi" placeholder="请输入金币数量" type="number"></el-input>
                    </div>
                </div>
                
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="setJinBi()">确认</el-button>
                </div>

            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isSendZeGoMsgTip" :title="sendMsgtitle" width="1000px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        消息
                    </div>
                    <div class="value" style="width:400px">
                        <el-input v-model="sendMsg.content" placeholder="" type="textarea"></el-input>
                    </div>
                </div>

                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="SendZeGoMsg()">确认</el-button>
                </div>

            </div>
        </el-dialog>
      <!-- 大图预览 -->
      <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
        

    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS} from '../../../utils/index'
import {genderList,vipList,shenHeList,enableList} from '../../../assets/selectList/anxin'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'user',
    data () {
        return {
            userId:'',
            vipList:vipList,
            enableList:enableList,
            genderList:genderList,
            shenHeList:shenHeList,
            isShow:false,
            totalCount:0,
            isDetailDialog:false,
            isAgentDialog:false,
            detailData:{},
            agentData:{
                "userId": 0,
                "isAgent": true,
                "yongJinRatio": 0
            },
            piclist:[],
            conditionData:{
                // userId:'',
                // gender:'',
                // phone:'',
                // province:'',
                // city:'',
                // weChat:'',
                // qq:'',
                // vip:null,
                // isReal:null,
                // isTest:null,
                // reviewWeChatState:null,
                state:null,
                current:1,
                size:10,
            },
            tableData:[],
           

            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,
            userId:'',
            // 解锁次数
            isSetUnlockNumber:false,
            setUnlockNumberData:{},
            // 会员设置
            isVip:false,
            vipData:{},
            // 动态次数
            isDynamicNumberDialog:false,
            dynamicNumberData:{},

            frozenData:{
                "userId": null,
                "reason": ""
            },
            isFrozenDialog:false,
            username:'',
            thawData:{
                "userId": null,
                "reason": ""
            },
            isThawDialog:false,

            isJinBiDialog:false,
            JinBiData:{
                "userId": null,
                "jinBi": 0
            },
            isEditDialog:false,
            editData:{
                "id": 0,
                "userId": 0,
                "nickName": "",
                "age": 0,
                "gender": 1,
                "city": "",
                "birthday": "",
                "shenGao": "",
                "tiZhong": "",
                "zhiYe": "",
                "love": "",
                "header": "",
                "lng": 0,
                "lat": 0,
                "address": "",
                "weChat": "",
                "unlockNumber": 0
            },
            IsJUserList:[{
                label:'是',
                value:true,
            },{
                label:'否',
                value:false,
            }],
            IsAgentList:[{
                label:'是',
                value:true,
            },{
                label:'否',
                value:false,
            }],
            isSetNum:false,

            NUMList:{},
            sexList:[
                {
                    value:1,
                    label:'男'
                },{
                    value:2,
                    label:'女'
                }
            ],
            onlineStateList:[
                {
                    value:1,
                    label:'在线'
                },{
                    value:2,
                    label:'最近活跃'
                },{
                    value:3,
                    label:'离线'
                }
            ],
            DeviceTypeList:[
                {
                    value:1,
                    label:'安卓'
                },{
                    value:2,
                    label:'苹果'
                }
            ],
            PhoneTypeList:[
                {
                    value:0,
                    label:'通用'
                },{
                    value:1,
                    label:'华为'
                },{
                    value:2,
                    label:'小米'
                },{
                    value:3,
                    label:'Oppo'
                },{
                    value:4,
                    label:'Vivo'
                },{
                    value:5,
                    label:'三星'
                },{
                    value:10,
                    label:'苹果'
                },{
                    value:11,
                    label:'荣耀'
                },{
                    value:20,
                    label:'h5'
                }
            ],
            addNum:{

            },
            isAddBackDialog:false,
            addBackData:{
                "userId": null,
                "reason": ""
            },
            agentDialogType:1,

            zhongJieData:{
                "userId": 0,
                "isZhongJie": true,
                // "yongJinRatio": 0
            },
            zhongJieType:1,
            isZhongJieDialog:false,
            zhongJieDialogType:null,
            setZhongJieData:{
                "agentId": 0,
                "zAgentId": 0
            },
            isZhongJieDialog:false,
            isTuanZhangListDialog:false,
            isAddTuanZhangListDialog:false,
            userList:[],

            addUserListSelect:{
                phone:'',
                weChat:'',
                nickName:'',
                current:1,
                size:10,
                DeviceType:null,
                PhoneType:null,
            },
            addUserList:[],
            addUserListTotal:0,
            zhongJie:{
                "agentUserId": 0,
                "userId": 0,
                "yongJinRatio": 0
            },
            isBangDingDialog:false,
            isSendZeGoMsgTip:false,
            sendMsg:{
                userIds:[],
                content:'',
            },
            sendMsgtitle:'',
            isExpertDialog:false,
            expertData:{
                startTime:'',
                totalRecharge:100
            },
            isList:[{
                label:'是',
                value:true,
            },{
                label:'否',
                value:false,
            }],
            reviewWeChatStateList:[
            {
                label:'审核中',
                value:0,
            },{
                label:'审核通过',
                value:1,
            },{
                label:'审核不通过',
                value:-1,
            }
            ]
        }
    },
    components:{
        ElImageViewer
    },
    created(){

    },
    mounted(){
        // if(localStorage.getItem('userCon')){
        //     console.log(localStorage.getItem('userCon'));
        //     this.conditionData = JSON.parse(localStorage.getItem('userCon'));
        //     this.totalCount = this.conditionData.page*10
        //     this.$forceUpdate();
        // }
        this.loadingData();
        // this.getNum();
    },
    methods:{
        async expertFile(){
            let res = await api.expertFile({
                type:2,
                condition:this.expertData
            },'用户数据');
        },
        expertUser(){
            this.isExpertDialog = true
        },
        SendZeGoMsgTip(row){
            this.sendMsg.sendUserId = 0;
            this.sendMsg.toUserId = row.userId
            this.isSendZeGoMsgTip = true
            this.sendMsgtitle = row.nickName
        },
        async SendZeGoMsg(){
            console.log('SendZeGoMsg')
            console.log(this.sendMsg)
            let res = await api.SendZeGoMsg(this.sendMsg);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '发送成功'
                }); 
                this.isSendZeGoMsgTip = false;
            }
        },
        async selectBangDingTip(row){
            this.zhongJie.agentUserId = row.userId
            this.isBangDingDialog = true;
        },
        async selectBangDing(row){
            this.zhongJie.yongJinRatio = parseFloat(this.zhongJie.yongJinRatio);
            let res  = await api.BindZhongJie(this.zhongJie);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '设置成功'
                }); 
                this.isBangDingDialog = false;
                this.isAddTuanZhangListDialog = false;
                
                this.tuanZhangListDialog({userId:this.zhongJie.userId});
            }
        },
        async deleteBangDing(row){
            let res  = await api.UnbindZhongJie({
                userId:this.zhongJie.userId,
                agentUserId: row.userId,
            });
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                }); 
                this.isBangDingDialog = false;

                this.tuanZhangListDialog({userId:this.zhongJie.userId});
            }
        },
        async addTuanZhangDialogShow(){
            this.isAddTuanZhangListDialog = true;
            let res  = await api.UserInfoPager(this.addUserListSelect);
            console.log(res);
            this.addUserList = res.data.data.data;
            this.addUserListTotal = res.data.data.totalCount;
            for(let index in this.addUserList){
                this.addUserList[index].Time = parseTimeS(this.tableData[index].Time);
            }
        },
        async tuanZhangListDialog(row){
            this.isTuanZhangListDialog = true;
            this.zhongJie = {
                "agentUserId": 0,
                "userId": row.userId,
                "yongJinRatio": 0
            }
            let res = await api.AdminAgentQueryAgentByAgentZUserId({
                userId:row.userId
            });
            console.log(res.data)
            this.userList = res.data.data;
        },
        // async AdminStandSetZhongJie(){
        //     let res = await api.AdminStandSetZhongJie(this.setZhongJieData);
        // },
        async AgentDialog(item,type){
            this.agentData.isAgent = item.isAgent;
            this.agentData.userId = item.userId;
            this.agentData.yongJinRatio = item.yongJinRatio;
            this.isAgentDialog = true;
            this.agentDialogType = type;
        },
        async intermediaryDialog(item,type){
            this.zhongJieData.isZhongJie = item.isZhongJie;
            this.zhongJieData.userId = item.userId;
            // this.zhongJieData.yongJinRatio = item.yongJinRatio;
            this.isZhongJieDialog = true;
            this.zhongJieDialogType = type;
        },
        async setZhongJie(){
            // if(this.zhongJieData.yongJinRatio>1){
            //     this.$message({
            //         type: 'warning',
            //         message: '佣金比例不能大于1'
            //     }); 
            //     return;
            // }
            // this.zhongJieData.yongJinRatio = parseFloat(this.zhongJieData.yongJinRatio);
            let res = await api.AdminStandSetZhongJie(this.zhongJieData);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '设置成功'
                }); 
                this.isZhongJieDialog = false;
                this.loadingData();
            }
        },
        async setAgent(){
            if(this.agentData.yongJinRatio>1){
                this.$message({
                    type: 'warning',
                    message: '佣金比例不能大于1'
                }); 
                return;
            }
            this.agentData.yongJinRatio = parseFloat(this.agentData.yongJinRatio);
            let res = await api.AdminStandUpdateUser(this.agentData);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '设置成功'
                }); 
                this.isAgentDialog = false;
                this.loadingData();
            }
        },
        async uploadHeader(file){
            let res= await api.uploadFile(file.file);
            this.editData.header = res;
        },
        addBacktTip(row){
            this.addBackData = {
                userId:row.userId,
                phone: row.phone,
                nickName: row.nickName,
                weChat: row.weChat,
                device: row.device,
                reason:'',
            }
            this.isAddBackDialog = true;
        },
        async LaHei(){
            let res = await api.LaHei(this.addBackData);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '新增成功'
                }); 
                this.isAddBackDialog = false;
                this.loadingData();
            }
        },
        async setNum(){
            let res = await api.SetWomanOnline(this.addNum);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '新增成功'
                }); 
                this.isSetNum = false;
            }
        },
        async getNum(){
            let res = await api.QueryUserOnline();
            this.NUMList = res.data.data;
        },
        delPicTip(row){
            this.$confirm('将删除此照片?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delPic(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        // async QueryUserInfoPicByUserId(row){
        //     console.log(row);
        //     return;
        //     let res = await api.QueryUserInfoPicByUserId();
        //     console.log(res);
        // },
        async delPic(row){
            let res = await api.deleteUserInfoPicById(row.id);
            if(res.data.code == '200'){
                this.isEditDialog = false;
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });   
                this.isDetailDialogShow({userId:this.userId});
            }
        },
        deleteTip(row){
            console.log(row);
            this.$confirm('将删除用户?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteItem(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        updateTip(row){
            this.editData = row;
            this.isEditDialog = true;
            this.username = row.nickName;
        },
        async editDataFun(){
            let res = await api.AdminStandUpdateUserInfo(this.editData);
            console.log(res);
            if(res.data.code == '200'){
                this.isEditDialog = false;
                this.$message({
                    type: 'success',
                    message: '编辑成功'
                });   
                this.loadingData();
            }
        },
        async deleteItem(row){
            let res = await api.deleteUser(row.userId);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });   
                this.loadingData();
            }
        },
        // 动态次数
        dynamicNumberDialog(row){
            console.log(row);
            this.isDynamicNumberDialog = true;
            this.dynamicNumberData = {
                "userId": row.userId,
                "dynamicNumber": 0,
            };
        },
        async setDynamicNumberData(){
            this.isDynamicNumberDialog = false;
            this.dynamicNumberData.dynamicNumber = parseFloat(this.dynamicNumberData.dynamicNumber)
            let res = await api.setDynamicNumber(this.dynamicNumberData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '设置成功!'
                });
                this.loadingData();
            }
        },
        // 设置vip
        vip(row){
            this.isVip = true;
            this.vipData = {
                "userId": row.userId,
                "vip": row.vip,
                "vipEndDate":row.vipEndDate
            };
        },
        async setVip(){
            this.isVip = false;
            let res = await api.AdminStandSetVip(this.vipData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '设置成功!'
                });
                this.loadingData();
            }
        },

        setJinBiTip(row){
            this.isJinBiDialog = true;
            this.JinBiData = {
                "userId": row.userId,
                "jinBi": '',
            };
        },
        async setJinBi(){
            this.JinBiData.jinBi = parseFloat(this.JinBiData.jinBi?this.JinBiData.jinBi:0);
            let res = await api.AdminStandSetJinbi(this.JinBiData);
            if(res.data.code == "200"){
                this.isJinBiDialog = false;
                this.$message({
                    type: 'success',
                    message: '设置金币成功!'
                });
                this.loadingData();
            }
        },
        // 解锁次数
        setUnlockNumber(row){
            this.isSetUnlockNumber = true;
            this.setUnlockNumberData = {
                "userId": row.userId,
                "unlockNumber": 0,
            };
        },
        async setUnlockNumberApi(){
            this.isSetUnlockNumber = false;
            this.setUnlockNumberData.unlockNumber = parseFloat(this.setUnlockNumberData.unlockNumber)
            let res = await api.AdminStandSetUnlockNumber(this.setUnlockNumberData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '设置成功!'
                });
                this.loadingData();
            }
        },
        // 冻结提示
        dongjieTip(item){
            this.username = item.nickName
            this.frozenData.userId = item.userId;
            this.isFrozenDialog =true;
        },
        async dongjie(){
            let res = await api.AdminStandFrozen(this.frozenData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '冻结成功!'
                });
                this.isFrozenDialog =false;
                this.loadingData();
            }
        },

        // 解冻提示
        jiedongTip(item){
            this.username = item.nickName
            this.thawData.userId = item.userId;
            this.isThawDialog =true;
            this.thawData.state = 1;
            this.jiedong();
        },
        async jiedong(){
            let res = await api.AdminStandThaw(this.thawData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '解冻成功!'
                });
                this.isThawDialog =false;
                this.loadingData();
            }
        },
        auditUser(row){
        },
        // 审核图片
        async auditPic(item){
            console.log(item);
            this.$confirm('将审核通过?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.auditPicApi(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
            return
        },
        async auditPicApi(item){
            let res = await api.shenHeUserInfoPic({
                userId:item.userId,
                userInfoPicId:item.id,
                shenHe:2,
            });
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '审核成功!'
                });
                this.isDetailDialogShow({userId:this.userId});
            }
        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showHeader(url){
            console.log(url)
            this.showBigImgList = [url];
            this.showBigImg = true;

        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.UserInfoPager(this.conditionData);
            
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
            for(let index in this.tableData){
                this.tableData[index].Time = parseTimeS(this.tableData[index].Time);
            }
        },
        selectData(){
            this.conditionData.current = 1;
            localStorage.setItem('userCon',JSON.stringify(this.conditionData));
            this.loadingData();
        },
        selectBangDingData(){
            this.addUserListSelect.current = 1;
            this.addTuanZhangDialogShow();
        },
        
        
        handleCurrentChange(page){
            this.conditionData.current = page;
            localStorage.setItem('userCon',JSON.stringify(this.conditionData));
            this.loadingData();
        },
        handleBangDingCurrentChange(page){
            this.addUserListSelect.current = page;
            this.addTuanZhangDialogShow();
        },
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        handleBangDingChange(size){
            this.addUserListSelect.current = 1;
            this.addUserListSelect.size = size;
            this.addTuanZhangDialogShow();
        },
        async isDetailDialogShow(row){
            this.isDetailDialog = true;
            // this.detailData = row;
            let res = await api.QueryUserInfoPicByUserId(row.userId);
            console.log(res);
            this.piclist = res.data.data;
            this.userId = row.userId;
            // this.isDetailDialogShow();
        },
       
        // 重置
        reset(){
            localStorage.removeItem('userCon');
            this.conditionData = {
                state:null,
                current: 1,
                size: 10,
            },
            this.loadingData();
        },
        
        async getUserData(){
            let res = await api.getUserData({
                type:1,
                condition:this.conditionData
            },'用户数据');
        },
        
       
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        
        /deep/.table-expand {
            font-size: 0;
        }
        .row{
            display: flex;
        }
        /deep/.table-expand label {
            width: 150px;
            padding-left: 50px;
            color: #99a9bf;
        }
        /deep/.table-expand span {
            color: #222222;
        }
        /deep/.table-expand .btn span{
            color: #409eff;
        }
        /deep/.table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 450px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 215px;
                display: flex;
            }
            .valuet{
                width: 450px;
            }
            .header{
                display: flex;
                align-items: center;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: 0;
                    right: 0;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: rgba(0, 0, 0 , 0.6);
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
